import Vue from 'vue';
//import Vue from 'vue/dist/vue.runtime.esm.js';

    export default Vue.component('googlemaps', {
		template: '<div ref="map" style="height:100%;width:100%"><slot></slot></div>',
		beforeCreate() {
		},
      data: function () {
        return {
          map: null,
          directionsService: null,
          directionsRenderer: null,
          infoWindow: null,
          dataLayers: [],
          overlayPolylines: []
        }
      },
    	props: {
        apikey:{
          type:String,
          default:''
        },
        zoom:{
          type:Number,
          default:10
        },
        minzoom:{
          type:Number,
          default:null
        },
        maxzoom:{
          type:Number,
          default:null
        },
        travelmode:{
          type:String,
          default:'DRIVING'
        },
        optimizeWaypoints:{
          type:Boolean,
          default:false
        },
        routeorigin:{
          type:String,
          default:""
        },
        routedestination:{
          type:String,
          default:""
        },
        routewaypoints:{
          type:Array,
          default:null
        },
        calculateroute:{
          type:Boolean,
          default:false
        },
        // Single layer (legacy): knooppunten
        geojson:{
          type:Object,
          default:''
        },
        // Multiple GeoJSON layers: [{ src, type, fitBounds, clickable }]
        // type: 'knooppunten' | 'route' | 'poi' | 'default'
        geojsonlayers:{
          type:Array,
          default: function(){ return []; }
        },
        styles:{
          type:Array,
          default:''
        },
        mapid:{
          type:String,
          default:''
        },
        zoomcontrol:{
          type:Boolean,
          default:true
        },
        gesturehandling:{
          type:String,
          default:'auto'
        },
        streetviewcontrol:{
          type:Boolean,
          default:true
        },
        scrollwheel:{
          type:Boolean,
          default:true
        }
    	},

    	mounted: function() {

        this.checkAndAttachMapScript(this.callBack);

    	},
      beforeDestroy () {
        if (this.infoWindow) {
          this.infoWindow.close();
        }
        this.dataLayers.forEach(function(layer){
          layer.setMap(null);
        });
        this.dataLayers = [];
        this.overlayPolylines.forEach(function(polyline){
          polyline.setMap(null);
        });
        this.overlayPolylines = [];
      },
      created() {

      },
    	computed: {
    	},

    	methods: {

        checkAndAttachMapScript : function (callback) {
           if (!!window.google) {
              callback();
              return true;
           }

           window.mapApiInitialized = callback;
           let script = document.createElement('script');
           script.async = true;
           script.src = 'https://maps.googleapis.com/maps/api/js?key='+this.apikey+'&libraries=places,geometry&callback=mapApiInitialized&loading=async';
           document.body.appendChild(script);
        },

        callBack : function(){
          this.initMap();
        },

        initMap : function(){

          var mapCanvas = this.$refs.map;
          var myOptions = {
              zoom:this.zoom,
              minZoom:this.minzoom,
              maxZoom:this.maxzoom,
              zoomControl:this.zoomcontrol,
              gestureHandling:this.gesturehandling,
              center:new google.maps.LatLng(51.194585,4.4209588),
              mapTypeId: 'roadmap',
              disableDefaultUI: false,
              scrollwheel: false,
              navigationControl: true,
              mapTypeControl: false,
              scaleControl: true,
              draggable:true,
              streetViewControl: this.streetviewcontrol,
              scrollwheel: this.scrollwheel
          };
          if (this.styles!='')  myOptions.styles = this.styles;
          if (this.mapid!='')   myOptions.mapId = this.mapid;

          this.map = new google.maps.Map( mapCanvas , myOptions);
          this.infoWindow = new google.maps.InfoWindow();

          if (this.calculateroute){
              this.directionsService = new google.maps.DirectionsService();
              this.directionsRenderer = new google.maps.DirectionsRenderer();

              this.directionsRenderer.setMap(this.map);
              this.calcRoute(this.directionsService, this.directionsRenderer);
          }

          var layers = this.geojsonlayers.slice();

          if (this.geojson && this.geojson.src) {
            layers.unshift({
              src: this.geojson.src,
              type: 'knooppunten',
              clickable: false,
              fitBounds: false
            });
          }

          layers.forEach((layer) => {
            if (layer && layer.src) {
              this.loadGeoJsonLayer(layer);
            }
          });

        },

        geoCodeAddress : function (address){

          var geocoder = new google.maps.Geocoder();

          geocoder.geocode( { 'address': address}, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              return results[0].geometry.location;
            }
          });

        },


        addMarker : function(position, title, icon){

          var marker = new google.maps.Marker({
              map: this.map,
              animation: google.maps.Animation.DROP,
              position: position,
              title: title,
          });

        },

        calcRoute : function(directionsService, directionsRenderer){

          var request = {
                  origin: this.routeorigin,
                  destination: this.routedestination,
                  waypoints: this.routewaypoints,
                  provideRouteAlternatives: false,
                  optimizeWaypoints: this.optimizeWaypoints,
                  travelMode: google.maps.TravelMode.WALKING
              };

          directionsService.route(request, function(response, status) {
            if (status == google.maps.DirectionsStatus.OK) {
              directionsRenderer.setDirections(response);
            } else {
              alert("directions response "+status);
            }
          });


        },

        loadGeoJsonLayer : function(layer){
          var self = this;
          var dataLayer = new google.maps.Data({ map: this.map });
          var type = layer.type || 'default';
          var clickable = layer.clickable !== false && type !== 'knooppunten';

          dataLayer.setStyle(function(feature){
            return self.styleForFeature(type, feature, clickable);
          });

          if (clickable) {
            dataLayer.addListener('click', function(event){
              self.showFeatureInfo(event);
            });
          }

          dataLayer.loadGeoJson(layer.src, null, function(features){
            if (features && features.length) {
              features.forEach(function(feature){
                if (self.isShortRouteFeature(feature)) {
                  self.addDashedRouteOverlay(feature);
                }
              });
            }
            if (layer.fitBounds && features && features.length) {
              var bounds = new google.maps.LatLngBounds();
              var hasGeometry = false;
              features.forEach(function(feature){
                var geometry = feature.getGeometry();
                if (!geometry) return;
                geometry.forEachLatLng(function(latLng){
                  bounds.extend(latLng);
                  hasGeometry = true;
                });
              });
              if (hasGeometry) {
                self.map.fitBounds(bounds);
              }
            }
          });

          this.dataLayers.push(dataLayer);
        },

        isShortRouteFeature : function(feature){
          var name = feature.getProperty('name');
          if (!name || typeof name !== 'string') {
            return false;
          }
          return name.toLowerCase().indexOf('verkorting') !== -1;
        },

        isBikeShortRouteFeature : function(feature){
          var name = feature.getProperty('name');
          if (!name || typeof name !== 'string') {
            return false;
          }
          return name.toLowerCase().indexOf('verkorting-fiets') !== -1;
        },

        addDashedRouteOverlay : function(feature){
          var geometry = feature.getGeometry();
          if (!geometry) return;

          var paths = [];
          var geometryType = geometry.getType();
          if (geometryType === 'LineString') {
            paths.push(geometry.getArray());
          } else if (geometryType === 'MultiLineString') {
            geometry.getArray().forEach(function(line){
              paths.push(line.getArray());
            });
          } else {
            return;
          }

          // Fiets-verkorting: vaste donkergroene stippellijn
          var strokeColor = this.isBikeShortRouteFeature(feature)
            ? '#097138'
            : (feature.getProperty('stroke') || '#1565C0');
          var strokeWeight = feature.getProperty('stroke-width') || 5;
          var self = this;

          paths.forEach(function(path){
            var polyline = new google.maps.Polyline({
              path: path,
              map: self.map,
              clickable: false,
              strokeOpacity: 0,
              zIndex: 3,
              icons: [{
                icon: {
                  path: 'M 0,-1 0,1',
                  strokeOpacity: 1,
                  strokeColor: strokeColor,
                  strokeWeight: strokeWeight,
                  scale: 3
                },
                offset: '0',
                repeat: '14px'
              }]
            });
            self.overlayPolylines.push(polyline);
          });
        },

        styleForFeature : function(type, feature, clickable){
          var geometry = feature.getGeometry();
          var geometryType = geometry ? geometry.getType() : null;

          if (type === 'knooppunten') {
            return {
              clickable: false,
              icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 10,
                fillColor: 'white',
                strokeColor: 'black',
                strokeWeight: 1,
                fillOpacity: 1,
                labelOrigin: new google.maps.Point(0, 0)
              },
              label: {
                color: 'black',
                fontFamily: 'Arial',
                fontSize: '10px',
                fontWeight: '400',
                text: String(feature.getProperty('knoopnr') || '')
              }
            };
          }

          if (geometryType === 'LineString' || geometryType === 'MultiLineString') {
            // Short routes (verkorting): hide solid Data stroke; dashed overlay is drawn separately
            if (this.isShortRouteFeature(feature)) {
              return {
                clickable: false,
                strokeOpacity: 0,
                zIndex: 3
              };
            }

            return {
              clickable: false,
              strokeColor: feature.getProperty('stroke') || '#c45c26',
              strokeOpacity: feature.getProperty('stroke-opacity') != null ? feature.getProperty('stroke-opacity') : 0.95,
              strokeWeight: feature.getProperty('stroke-width') || 4,
              zIndex: 2
            };
          }

          if (type === 'route') {
            var routeNumber = this.getRoutePointNumber(feature);
            if (routeNumber) {
              return {
                clickable: !!clickable,
                title: feature.getProperty('name') || '',
                icon: {
                  url: '/map-data/iconen/poi_' + routeNumber + '.svg',
                  scaledSize: new google.maps.Size(28, 28),
                  size: new google.maps.Size(28, 28),
                  anchor: new google.maps.Point(14, 14)
                },
                zIndex: 4
              };
            }

            if (this.isRouteStartPoint(feature)) {
              return {
                clickable: !!clickable,
                title: feature.getProperty('name') || 'Vertrekpunt',
                icon: {
                  url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                  scaledSize: new google.maps.Size(36, 36),
                  size: new google.maps.Size(36, 36),
                  anchor: new google.maps.Point(18, 36)
                },
                zIndex: 1000
              };
            }

            // Other GPX markers without a POI number (e.g. einde)
            return { visible: false };
          }

          if (type === 'labelhouders' || type === 'infopunten') {
            var customIcon = this.resolveLayerIconUrl(type, feature);
            if (customIcon) {
              return {
                clickable: !!clickable,
                title: feature.getProperty('name') || '',
                icon: {
                  url: customIcon,
                  scaledSize: new google.maps.Size(32, 32),
                  size: new google.maps.Size(32, 32),
                  anchor: new google.maps.Point(16, 16)
                },
                zIndex: 3
              };
            }
          }

          if (type === 'poi' || type === 'default') {
            return {
              clickable: !!clickable,
              title: feature.getProperty('name') || '',
              icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 7,
                fillColor: '#0288D1',
                strokeColor: '#ffffff',
                strokeWeight: 2,
                fillOpacity: 1
              },
              zIndex: 3
            };
          }

          return {
            clickable: !!clickable
          };
        },

        resolveLayerIconUrl : function(type, feature){
          var icon = feature.getProperty('icon');
          if (!icon || typeof icon !== 'string') {
            return null;
          }

          var fileName = icon.replace(/^images\//, '');
          if (!fileName) {
            return null;
          }

          if (type === 'labelhouders') {
            return '/map-data/labelhouders/' + fileName;
          }
          if (type === 'infopunten') {
            return '/map-data/infopunten/' + fileName;
          }
          return null;
        },

        getRoutePointNumber : function(feature){
          var nummer = feature.getProperty('nummer');
          if (nummer == null || nummer === '') {
            return null;
          }
          var n = parseInt(nummer, 10);
          if (!n || n < 1 || n > 15) {
            return null;
          }
          return n;
        },

        isRouteStartPoint : function(feature){
          var name = feature.getProperty('name');
          if (!name || typeof name !== 'string') {
            return false;
          }
          return name.trim().toLowerCase().indexOf('vertrekpunt') !== -1;
        },

        showFeatureInfo : function(event){
          var name = event.feature.getProperty('name') || '';
          var description = this.normalizeDescription(event.feature.getProperty('description'));

          if (!name && !description) {
            return;
          }

          var content = '<div class="map-feature-info" style="max-width:260px">';
          if (name) {
            content += '<strong>' + name + '</strong>';
          }
          if (description) {
            content += '<div style="margin-top:6px">' + description + '</div>';
          }
          content += '</div>';

          this.infoWindow.setContent(content);
          this.infoWindow.setPosition(event.latLng);
          this.infoWindow.open(this.map);
        },

        normalizeDescription : function(description){
          if (!description) return '';
          var html = '';
          if (typeof description === 'string') {
            html = description;
          } else if (typeof description === 'object' && description.value) {
            html = description.value;
          } else {
            return '';
          }

          // Drop My Maps / broken hosted images from InfoWindows
          html = html.replace(/<img\b[^>]*>/gi, '');
          html = html.replace(/(?:<br\s*\/?>\s*){2,}/gi, '<br><br>');
          html = html.replace(/^(?:\s|<br\s*\/?>)+|(?:\s|<br\s*\/?>)+$/gi, '');
          return html;
        }

      }

    });
